{
  "CCPADontSellButton": "Do Not Sell Or Share My Personal Information",
  "NewAddressAdding": "Unit can be entered in next step",
  "RemoveDeliveryAddressConfirmation": "Remove Delivery Address Confirmation",
  "about": "About",
  "accept": "Accept",
  "acceptEmailsAndSpecialOffers": "I want to receive special offers and other information from Burger King via email",
  "acceptGiftSuccess": "You have received a {gift} from {fullName}. The gift has been added to your account and will appear along with other offers. Don’t forget to activate it.",
  "acceptMarketingSMSCommPrefs": "I agree to receive recurring autodialed telemarketing text messages from Burger King at the telephone number provided above and understand that my consent is not a condition of purchase. Messages & data rates may apply.",
  "acceptOrderModal": "Please have this order ready for {serviceMode} by {time} on {date}. You will not be able to decline an order after accepting it here.",
  "acceptTermsAndPrivacyCommPrefs": "I have read and agree to the {bkRoyalPerksTextProgramLink}, the {privacyPolicyLink}, and {rewardsPolicyLink}.",
  "acceptTermsAndPrivacyIntro": "I agree to the following: {privacyPolicyLink}, {rewardsPolicyLink}, {termsOfServiceLink}",
  "account": "Account",
  "accountDefault": "default",
  "accountDetails": "Account Details",
  "accountInfo": "Account Info",
  "accountRewardsPoints": "You have {points} available",
  "accountRewardsPointsExpiration": "{pointsToExpire} Crowns will expire \n {expirationDateTime}",
  "accountWithEmailAlreadyExists": "An account with the given email already exists.",
  "activate": "Activate",
  "active": "Active",
  "add": "Add",
  "addCondiments": "Add Condiments",
  "addCreditCard": "Add a Credit Card",
  "addCreditDebitCard": "Add Debit / Credit Card",
  "addFavorite": "Add to Favorites",
  "addFromCheckout": "Add from checkout",
  "addGiftCard": "Add Gift Card",
  "addItemLabel": "Add one {itemName} to your cart?",
  "addItemToCart": "Add {name} to cart",
  "addItemToCartWithModifiers": "Add {name} with {modifiers} to cart",
  "addItems": "Add Items",
  "addItemsLowerCase": "Add items",
  "addNewCard": "Add New Debit or Credit Card",
  "addNewPaymentMethod": "Add New Payment Method",
  "addNewPaymentMethodGiftCard": "Add a Gift Card",
  "addOffer": "Add Offer",
  "addOffers": "Add Offers",
  "addPayment": "Add Payment",
  "addPaymentMethod": "Add Payment Method",
  "addPaymentMethodOrReload": "Add Payment Method",
  "addPrepaidCard": "Add a BK Gift Card",
  "addQuantityAndItemWithPrice": "Add {quantity} {itemName} to order for {price}",
  "addReward": "Add Reward",
  "addRewards": "Add Rewards",
  "addToCart": "Add",
  "addToCartCarousel": "Add to Cart",
  "addToCartError": "Unable to add {itemName} to cart. Please try again.",
  "addToCartMultipleSuccess": "{itemName} and {quantity} {quantity, plural, one {other} other {others}} added to cart",
  "addToCartSuccess": "{itemName} added to cart",
  "addToOrder": "Add to Order",
  "addToOrderHeader": "Add to Order",
  "added": "Added",
  "additionalInfoIngredients": "Ingredients",
  "addons": "Add-Ons",
  "address": "Address",
  "addressError": "Oops! Address not recognized.",
  "addressRequired": "Address (Required)",
  "addressRequiredError": "Address is a required field.",
  "adsPersonalization": "Interest-based Advertising",
  "adsPersonalizationInfo": "If enabled, we may share your contact information and device id with social media and other third-party platforms to help us deliver ads & offers that may interest you and others. You may opt out at any time, but please note that opting out may affect the relevance of the ads & offers that you may receive. To learn more, please see the {privacyPolicyLink}.",
  "afterDiscount": "After discount",
  "afternoon": "Afternoon",
  "agreeToTermsOfService": "Agree to terms of service",
  "agreeToTermsOfServiceError": "You must agree to the privacy policy and terms of service before signing up.",
  "agreeToTheTerms": "You must agree to the terms to enable SMS marketing communications.",
  "aliasAutoRenamed": "The selected alias was already used and has been renamed automatically.",
  "aliasError": "Please select a label (Home, Work, or Other).",
  "aliasLabelHome": "Home",
  "aliasLabelOther": "Other",
  "aliasLabelWork": "Work",
  "allRightsReserved": "All Rights Reserved.",
  "allergenInformation": "Allergen Information",
  "allergensDisclaimerContains": "This item contains {allergens}. Modifications are not represented in this list.",
  "allergensDisclaimerContainsAndMayBeCookedOn": "This item contains {allergens} and may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerContainsAndMayContain": "This item contains {allergens} and may contain {maybeAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerContainsAndMayContainAndMayBeCooked": "This item contains {allergens}, may contain {maybeAllergens}, and may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerMayBeCookedOn": "This item may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerMayContain": "This item may contain {maybeAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerMayContainAndMayBeCookedOn": "This item may contain {maybeAllergens} and may be cooked on same equipment as {maybeCookedOnAllergens}. Modifications are not represented in this list.",
  "allergensDisclaimerUnknown": "This item may have allergens.",
  "allowCameraAccess": "Allow BK app to access your camera",
  "allowCameraAccessWebText": "Enable your camera access to take photos. Use the camera icon in the browser bar or allow access through your browser settings.",
  "allowCameraAccessWebTitle": "Let BK.com use your camera",
  "amenities": "Amenities",
  "amount": "amount",
  "amountMore": "+{amountMore} more",
  "and": "and",
  "androidDownloadApp": "Android Download app button",
  "apartment": "Apartment",
  "appImage": "app-image",
  "applePay": "Apple Pay",
  "applePayPaymentNotAvailable": "We currently don’t accept Apple Pay on our websites. Please select or add a new payment method.",
  "apply": "Apply",
  "applyPromoCode": "Apply Promo Code",
  "aptOrSuite": "Apt or Suite",
  "areDeliveryDetailsValid": "We are unable to confirm your phone number. Please confirm your phone number is correct or try a different one.",
  "at": "at",
  "attachedToMyCodeSuccess": "{type} attached to My Code.",
  "authEmailSentEmail": "We sent an email with login instructions to",
  "authError": "An error occurred logging in",
  "authRetryError": "An error occurred. Press below to try again.",
  "authVerifyWithCode": "Verify with code",
  "autoReload": "Auto Reload",
  "autoReloadThreshold": "When my Tim Card balance is below:",
  "autoSignInSuccess": "Congratulations! Your account has been created.",
  "available": "Available",
  "availableAgainOn": "Available again on {date}",
  "availableCrowns": "Available Crowns",
  "availableForDelivery": "Available for Delivery",
  "availableForPickUp": "Available for Pickup",
  "availablePoints": "Available Crowns",
  "back": "Back",
  "backToMenu": "Back to menu",
  "backToOffers": "Back to offers",
  "backToTopics": "Back to topics",
  "backgroundImage": "background image",
  "badNetworkDialogBody": "To access all app features, please relocate to an area with stronger internet signal and retry.",
  "beforeDiscount": "Before discount",
  "billingAddressIsSameAsDeliveryAddress": "Billing address is same as delivery address.",
  "bk.pypestreamLoadingMessage": "One moment while we fire up support.",
  "bkBadges": "BK Badges",
  "bk_logo_title": "Burger King",
  "bonusPoints": "{points} Bonus Crown{points, plural, one {} other {s}}",
  "bonusPointsIncentiveDescription": "You've earned {points} bonus Crowns completing this challenge!",
  "bonusPointsLabel": "Bonus Crown{points, plural, one {} other {s}}",
  "breakfastDayPartEnds": "Breakfast ends in {minutes, plural, one {# min} other {# mins}}",
  "breakfastDayPartHours": "Breakfast available until {endDateHours}",
  "breakfastMenu": "Breakfast Menu",
  "button": "button",
  "cal": "Cal",
  "calculatingEta": "Calculating driver location",
  "calories": "Calories",
  "canOnlyChooseOneOfferLine1": "You can only choose one offer from this group.",
  "canOnlyChooseOneOfferLine2": "After you pick one, this group won't be shown again.",
  "canada": "Canada",
  "cancel": "Cancel",
  "cancellationPolicy": "No changes to the order can be made after placing your order.",
  "cancellationPolicyTitle": "Cancellation Policy",
  "cancelledOrderAction": "We're sorry, but it looks like your order has been cancelled and refunded. If you'd like to place your order again you can use the button below.",
  "cancelledOrderTitle": "Oh no! Your order was cancelled.",
  "cannotDeliveryTo": "We cannot currently deliver to",
  "cannotPlaceOrder": "Search for other restaurants nearby!",
  "cannotRemoveStoreFromFavorites": "In order to optimize your ordering experience to make it seamless, we need at least one favorite store.",
  "cannotRemoveStoreFromFavoritesHeader": "Cannot Remove Store From Favorites",
  "carbohydrates": "Carbohydrates",
  "card": "CARD",
  "cardAddedNotification": "Card added!",
  "cardAlias": "Crown",
  "cardAlias.bk": "Gift",
  "cardAlias.plk": "Gift",
  "cardAlias.th": "Tim",
  "cardCurrenciesDontMatch": "The Tim Card you are trying to transfer is from a different region than your account. Only Tim Cards from your region can be transferred.",
  "cardDeactivationError": "We were unable to process your request. Please try again or {link} for assistance.",
  "cardExpiration": "Card Expiration Date",
  "cardNumber": "Card Number",
  "cardNumberIsRequired": "Card number is required",
  "cardNumberRequiredError": "Card number is a required field.",
  "cardSuccessfullyLinked": "The card {cardId} was successfully linked to your account. Your Crowns may take a few minutes to appear in your account.",
  "cardUpdatedNotification": "Card Updated!",
  "cardXHasABalanceOfY": "Card {cardNumber} has a balance of {balance}",
  "careers": "Careers",
  "cart": "Cart",
  "cartCardLoadingMessage": "Firing Up Your Order...",
  "cartOfferRequirementsNotMetError": "The items in your cart do not meet the requirements of this offer",
  "cartV2_incentiveFeedbackCartRequirement": "Need to purchase {incentiveType}",
  "cartV2_incentiveFeedbackPaymentMethod": "Offer only applies by paying with {targetValue}",
  "cartV2_incentiveFeedbackSubtotal": "Needs Minimum Purchase of ${targetValue}",
  "cash": "Cash",
  "cashApp": "Cash App",
  "cashAppDecline": "Could not link Cash App Pay. Please try again or choose a different payment method.",
  "cashAppError": "Something went wrong. Please try again or select a different payment method.",
  "cashAppPay": "Cash App Pay",
  "catering": "Catering",
  "ccNumberIsNotValid": "Card Number is not valid",
  "celery": "celery",
  "challenge": "Challenge",
  "challengeActivated": "Activated",
  "challengeDetailsIncentiveBadge": "your badge",
  "challengeDetailsIncentiveCrowns": "{bonusPoints} bonus Crowns",
  "challengeDetailsIncentiveOffer": "your offer",
  "challengeDetailsIncentiveReward": "your reward",
  "challengeDetailsPendingMessage": "{completedSteps} Done - just {remainingSteps} more to unlock {incentive}!",
  "challengeEndsInLabel": "Ends in {days, plural, one {# day} other {# days}}",
  "challengeStarted": "Challenge Started",
  "change": "Change",
  "changeRedemptionToInStore": "Are you sure you want to change to in-store redemption?",
  "changeRedemptionToInStoreConfirmLabel": "Change to in-store",
  "changeRedemptionToInStoreDescription": "Changing to in-store redemption will clear your cart. Are you sure you want to proceed?",
  "changeRedemptionToPickUp": "Are you sure you want to change to a mobile order?",
  "changeRedemptionToPickUpConfirmLabel": "Change to mobile order",
  "changeRedemptionToPickUpDescription": "Changing from in-store redemption to mobile order will clear your active perks. Are you sure you want to proceed?",
  "changeRestaurantDialogBody": "Changing your restaurant may result in differences in prices or item availability.",
  "changeRestaurantDialogBodyDelivery": "Changing your address may result in differences in prices or item availability.",
  "changeRestaurantDialogConfirmButtonLabel": "Change Restaurant",
  "changeRestaurantDialogConfirmButtonLabelDelivery": "Change Address",
  "changeRestaurantDialogHeading": "Change Restaurant?",
  "changeRestaurantDialogHeadingDelivery": "Change Address?",
  "changeServiceMode": "Change Service Mode",
  "changeStoreMessage": "Changing your store may result in differences in prices or item availability. Continue changing stores?",
  "changeStoreMessagePromptDisclaimer": "Changing your store may result in differences in prices and item availability.",
  "changeStoreMessagePromptDisclaimerV2": "Prices and availability may vary by restaurant.",
  "changeStores": "Change Stores",
  "changingYourStoreDisclaimer": "Store changes may result in differences in price or item availability.",
  "checkNetworkSettings": "Check your network settings and try again",
  "checkout": "Checkout",
  "checkoutPaymentMethodNeedRevaultError": "There was an issue with your payment method. Please re-add your payment method.",
  "cholesterol": "Cholesterol",
  "chooseAnotherLocation": "Choose Another Location",
  "chooseDifferentItem": "Please choose a different item.",
  "chooseDifferentOffer": "Please choose a different offer.",
  "chooseDrink": "Select Your Drink",
  "chooseItemAmount": "Choose {amount} {itemName}",
  "chooseSide": "Select Your Side",
  "chooseYourLocation": "Choose location",
  "city": "City",
  "cityRequiredError": "City is a required field",
  "clearFilter": "clear filter",
  "clearText": "Clear Text",
  "clickHereForDetails": "Click here for details",
  "clickToSelectLocation": "Click to select location",
  "close": "Close",
  "closeRestaurantInfoAccessibilityLabel": "Close restaurant details button, navigate back to the previous page",
  "closed": "Closed",
  "closesAt": "Closes at {time}",
  "closestStoreSelected": "We’ve selected the closest store to your current location.",
  "codeErrorMessage": "Couldn't retrieve your code.",
  "comboOfferSavings": "Savings",
  "comments": "Comments",
  "communicationPreferences": "Communication Preferences",
  "complete": "Complete",
  "completeBy": "Complete by",
  "completed": "Completed",
  "confirm": "confirm",
  "confirmDeletePaymentMethod": "Are you sure you want to delete this payment method?",
  "confirmDialogBody": "Please continue if you're ready to redeem in the restaurant.",
  "confirmYourStore": "Confirm Your Store",
  "confirmationDifferentLocation": "Choose a different location",
  "contact": "Contact",
  "contactCourier": "You can contact your courier at:",
  "contactSupport": "Contact Support",
  "containsAllergens": "Contains: {allergens}",
  "contentCardsSeparatorLabel": "You are all caught up",
  "continue": "Continue",
  "continueChallenge": "Continue Challenge",
  "continueCustomizing": "Continue Customizing",
  "continueEditing": "Continue Editing",
  "continueToCart": "Continue to Cart ({numberOfItemsInCart})",
  "continueWithEmail": "Continue with Email",
  "copy": "Copy",
  "couldNotLocateStore": "The store could not be located to complete your order. Please try again later.",
  "couldntProcessOrder": "Please try placing your order in-restaurant and provide your 6-digit code, or select a different restaurant.",
  "country": "Country",
  "couponWillExpire": "This coupon will expire in 15 minutes",
  "createAccountHeadline": "Create an Account to Get Started",
  "createAnAccount": "Create an Account",
  "createAnAccountErrors": "The form has {count, plural, one {# error} other {# errors}}.",
  "createAnAccountSubheader": "Welcome! You are creating an account using {email}",
  "credit": "Credit",
  "creditCardExpired": "Credit card number is expired",
  "creditCardNumber": "Card Number",
  "crownPoints": "Crown Points",
  "crowns": "Crowns",
  "crownsAllYours": "That's {points} Crowns — all yours!",
  "crownsAwayFromUnlockingMoreRewards": "Crowns away from unlocking more rewards",
  "crownsEarned": "{points} Crown{points, plural, one {} other {s}} Earned",
  "crownsEarnedKeepGoing": "{crowns} Crowns earned — keep going!",
  "crownsWillExpireOn": "Crowns will expire on",
  "curbside": "Curbside",
  "curbsideHours": "Curbside hours",
  "curbsideVehicleDescription": "Help us find you by describing your vehicle e.g. red SUV/license plate starting ABC (optional). When you arrive at the restaurant, find a parking spot. When your order is ready, we will bring it you.",
  "curbsideVehicleDescriptionPlaceholder": "Vehicle description",
  "currentBalance": "Current Balance: ",
  "currentServiceMode": "Current service mode",
  "currentServiceModeUnavailable": "The restaurant is not accepting {serviceMode} orders at this time. Change service mode or select a new store",
  "customizations": "Customizations",
  "cvv": "CVV",
  "cvvIsRequired": "CVV is required",
  "cvvMustBeAtLeast3Digits": "CVV must be at least 3 digits",
  "date": "Date",
  "dateOfBirth": "Date of birth",
  "dateOfBirthIsBelowMinimum": "The information you entered does not comply with our {termsLink} and our {privacyPolicyLink}",
  "dateOfBirthIsRequired": "Date of Birth is required",
  "day": "Day",
  "dayPlaceholder": "DD",
  "daypartAfterEndTime": "It's past {dayPart} time!",
  "daypartBeforeStartTime": "It's not {dayPart} time yet!",
  "daypartEndsAt": "{dayPart} ends at {endTime}",
  "daypartStartsAt": "{dayPart} starts at {startTime}",
  "daytime": "Daytime",
  "daytimeMenu": "Daytime Menu",
  "daytimeMenuHeader": "{daytimeStartTime} - {daytimeEndTime}",
  "daytimeMenuHeaderHours": "{daytimeStartTime} to close",
  "declineReason": "Decline reason",
  "decrementAriaLabel": "decrement-{productName}",
  "delete": "delete",
  "deleteAccount": "Delete Account",
  "deleteButtonText": "Delete",
  "deletePaymentMethod": "Delete payment method",
  "deliverHere": "Deliver Here",
  "deliverTo": "Deliver to",
  "delivered": "Delivered",
  "deliveringTo": "Delivering to",
  "deliveringToYourDoorAt": "Delivering to your door at",
  "delivery": "Delivery",
  "deliveryAddNewAddress": "Add new address",
  "deliveryAddress": "Delivery Address",
  "deliveryAddressFormatted": "{addressLine1}, {city}, {state} {zip}",
  "deliveryCheckingMessage": "We are checking which restaurant will service your address. This may take a few moments...",
  "deliveryClosed": "Delivery closed. Reselect your delivery address",
  "deliveryClosing": "Delivery ends in {minutes} min",
  "deliveryDelivered": "Delivered",
  "deliveryDetails": "Delivery details",
  "deliveryDetailsInstructions": "Delivery Instructions (Optional)",
  "deliveryDriverArrived": "Driver Arrived",
  "deliveryDriverEnroute": "Driver Enroute",
  "deliveryFee": "Delivery Fee",
  "deliveryFeeDescription": "Fixed fee applicable to each delivery order.",
  "deliveryFees": "Delivery Order Fees",
  "deliveryFeesStripeTier": "{fees} under {tier}",
  "deliveryFeesStripeTierEnd": "{fees} on orders {tier}+",
  "deliveryFeesStripeTitle": "Delivery Fees Apply",
  "deliveryFeesStripeTitleSuffix": "{amount} minimum order",
  "deliveryImage": "Delivery Image",
  "deliveryInfo": "Delivery Info",
  "deliveryInstructions": "Delivery Instructions",
  "deliveryLogoAlt": "Delivery service provider logo",
  "deliveryMinumumNotReached": "Sorry! Minimum order subtotal for delivery is {min}",
  "deliveryNotAvailable": "Delivery Unavailable",
  "deliveryOnly": "Delivery only",
  "deliveryOrder": "Delivery Order",
  "deliveryOrderBeingPrepared": "Being Prepared",
  "deliveryOrderPlaced": "Delivery Order Placed",
  "deliveryPhoneDisclosure": "Your phone number is required so that we can send you updates about your order and facilitate communication between you and your driver. Your phone number will not be visible to your driver.",
  "deliverySelectYourAddress": "Select your Delivery Address",
  "deliveryShouldSaveInfoCheckboxMessage": "Save my information for updates on order status and driver communication. Your number will not be visible to the driver.",
  "deliveryStatusDriverAssigned": "Your order is in the works",
  "deliveryStatusDriverAtCustomer": "Your courier is nearby!",
  "deliveryStatusDriverAtStore": "Your courier just picked up your order",
  "deliveryStatusDriverStarting": "Your courier is picking up your order",
  "deliveryStatusDriverUnassigned": "Your order is in the works",
  "deliveryStatusOrderAbandoned": "Your order has been delivered",
  "deliveryStatusOrderCancelled": "Your order has been cancelled",
  "deliveryStatusOrderCreated": "Your order is in the works",
  "deliveryStatusOrderDroppedOff": "Your order has been delivered",
  "deliveryStatusOrderError": "Error processing your order",
  "deliveryStatusOrderPickedUp": "Your courier is out for delivery!",
  "deliveryStatusOrderTimeout": "Timeout processing your order",
  "deliveryStatusQuoteError": "Error processing your order",
  "deliveryStatusQuoteRequested": "We are processing your order",
  "deliveryStatusQuoteSuccessful": "We received your order",
  "deliveryStatusQuoteUnavailable": "We can't process your order",
  "deliverySurcharge": "Delivery Surcharge",
  "deliverySurchargeMessage": "A {feeSurcharge} surcharge will be added to your delivery fee due to the distance between your delivery location and the nearest restaurant.",
  "deliveryTerms.ca.heading": "Canadian Delivery Fees:",
  "deliveryTerms.ca.mobileTitle": "Mobile Order and Payment Terms",
  "deliveryTerms.caFeeValue": "$3.00",
  "deliveryTerms.californiaHeading": "California:",
  "deliveryTerms.coloradoHeading": "Colorado:",
  "deliveryTerms.fee.ca.gte12.label": "Delivery on Orders ≥$12:",
  "deliveryTerms.fee.ca.gte12.value": "$2.99 Delivery Fee + 10% Service Fee",
  "deliveryTerms.fee.ca.lt12.label": "Delivery on Orders <$12:",
  "deliveryTerms.fee.ca.lt12.value": "$2.99 Delivery Fee + 10% Service Fee + $1.99 Small Cart Fee",
  "deliveryTerms.feeLabel": "Delivery Fee:",
  "deliveryTerms.feeValue": "$2.99 ($0 for orders $25+)",
  "deliveryTerms.intro": "Delivery offered at participating U.S. restaurants on the BK App and bk.com. Minimum $5 order required (before taxes and fees). Prices higher than at restaurants. BK account registration is required. Delivery powered by third-party delivery providers, and subject to availability and restaurant delivery hours. Print coupons are not valid on delivery orders. Not all digital offers are available on delivery. Check digital offer terms at bk.com/offers before ordering. Fees are based on order subtotal.",
  "deliveryTerms.intro.ca.part1": "Delivery offered at participating Canadian restaurants on the BK App and burgerking.ca. Delivery powered by third-party delivery providers, and subject to availability and restaurant delivery hours.",
  "deliveryTerms.intro.ca.part2": "Prices may be higher than at restaurants. Delivery order fees: Delivery Fee, Service Fee and Small Cart Fees may apply.",
  "deliveryTerms.intro.ca.part3": "Print coupons not valid on delivery orders. Not all digital offers available on delivery. Check digital offer terms at burgerking.ca/rewards/offers before ordering.",
  "deliveryTerms.retailFeeLabel": "Colorado Retail Delivery Fee:",
  "deliveryTerms.retailFeeValue": "A $0.29 Retail Delivery Fee is required by law for deliveries in the State of Colorado",
  "deliveryTerms.serviceFeeLabel": "Service Fee:",
  "deliveryTerms.serviceFeeValue": "15% of order subtotal",
  "deliveryTerms.smallCartLabel": "Small Cart Fee:",
  "deliveryTerms.smallCartValue": "$2.50 on orders under $10",
  "deliveryTerms.statesHeading": "All states (except California and Colorado):",
  "deliveryTerms.title": "Delivery on the BK App and bk.com",
  "deliveryTerms.title.ca": "Delivery on the BK App and burgerking.ca",
  "deliveryTermsHeading": "Delivery Terms",
  "deliveryTermsPrefix": "Delivery terms and fees apply. Prices may be higher than at restaurants. ",
  "deliveryTime": "Delivery Time",
  "describeIssue": "Describe your issue",
  "describeIssueAndIncludePhoneNumber": "Describe your issue (please include your phone number)",
  "describeYourVehicle": "Describe your vehicle",
  "descriptionLengthError": "Description must be between {min} to {max} characters long",
  "details": "Details",
  "deviceSettings": "Device Settings",
  "diagnostics": "Diagnostics",
  "dialog": "dialog",
  "didNotReceiveCodeHeading": "Didn't receive a code?",
  "differentDeviceError": "We noticed this isn't the device you requested this code from. To login with this device, please request a new code below.",
  "dineIn": "Dine In",
  "dineInAt": "Dine in at",
  "dineInHours": "Dine in hours",
  "dineInOrder": "Dine In Order",
  "dineInOrderPlaced": "Dine In Order Placed",
  "directions": "Directions",
  "discard": "Discard",
  "discardChanges": "Discard Changes",
  "distance": "Miles",
  "donation": "Donation",
  "done": "Done",
  "dontHaveWalmartAccount": "Sign up for a Walmart+ annual membership",
  "dontHaveWalmartAccountMonthly": "Sign up for a Walmart+ monthly membership",
  "dontHaveWalmartPlusAccount": "Don’t have a Walmart+ membership yet? No problem!",
  "driveThru": "Drive Thru",
  "driveThruAt": "Drive-thru at",
  "driveThruHours": "Drive Thru hours",
  "driveThruMobileOrderPlaced": "Mobile Order Drive Thru Placed",
  "driveThruOrder": "Drive Thru Order",
  "driveThruOrderPlaced": "Drive Thru Order Placed",
  "duplicate": "Duplicate",
  "duplicateAccounts": "Duplicate Accounts",
  "duplicateSupportFormSubmission": "A support ticket was already created for your issue. Please give us up to 48 hours to respond",
  "earnCrowns": "Earn Crowns",
  "earned": "You've earned",
  "eatIn": "Eat In",
  "edit": "Edit",
  "editAddress": "Edit Address",
  "editAddressFailed": "Unable to update address. Please try again.",
  "editFavorite": "Edit Favorite",
  "eggs": "eggs",
  "email": "Email",
  "emailAddress": "Email Address",
  "emailAddressDoesNotMatch": "Email address does not match",
  "emailPushPreferencesDescription": "Be the first to know about new menu items and offers.",
  "emailPushPreferencesTitle": "Updates and Offers",
  "emailRequiredError": "Email is a required field.",
  "emailVerificationSent": "Email sent! Please check your email for the verification link.",
  "emptyInboxCaption": "We are cooking something...hold on tight, we’ll let you know",
  "emptyInboxTitle": "Nothing new for now...",
  "emptyMenuHeading": "Select a Location to View Menu",
  "emptyMenuMessage": "Help us find your closest store by sharing your location or select a location manually",
  "emptyMyCodeHeading": "Select a Location to view My Code",
  "emptyOffersHeading": "Select a Location to View Offers",
  "enableLocationServices": "Enable Location Services",
  "enablePushNotificationsOnDevice": "To receive notifications from Burger King, you must first enable notifications in your device's settings.",
  "endsIn": "••••",
  "endsInRedesign": "*",
  "enterReceiptCode": "Enter Receipt Code to Earn",
  "errorBoundaryBody": "Something went wrong on our end. Take a look at our menu and offers while we take a look into this.",
  "errorBoundaryTitle": "Bummer",
  "errorCreatingSupportCase": "There was an error submitting your support case. Please try again",
  "errorDialogCooldownMessage": "We're currently preparing a similar order for you, are you sure you want to order again?",
  "errorDialogCooldownTitle": "Order in Progress",
  "errorDialogFavoriteStoreMessage": "To set a favorite store, first sign up or log in to an account.",
  "errorDialogFavoriteStoreTitle": "Log in required",
  "errorProcessingRequest": "Looks like there was an error processing your request.",
  "errorRetrievingRestaurants": "Could not retrieve restaurants",
  "errorWithPayment": "Something went wrong with your payment, please try a different form of payment.",
  "eta": "ETA",
  "etaFull": "Estimated Time of Arrival",
  "evening": "Evening",
  "exceedsBalanceLimit": "Exceeds Balance Limit",
  "exceedsRewardsBalance": "If you add this reward to your cart, you will exceed your current Crowns balance. Please remove the Crowns applied in your cart.",
  "exclusiveDeals": "Exclusive Deals",
  "exitDeliveryAddressMessage": "Exit Delivery Address With Unsaved Changes",
  "expirationDate": "Expiration Date",
  "expirationDateIsRequired": "Expiration date is required",
  "expire": "exp.",
  "expired": "Expired",
  "expiredCard": "Expired Card",
  "expiring": "expiring",
  "expiringWithDate": "expiring {expiringDate}.",
  "faq": "Frequently Asked Questions",
  "fastLaneDriveThru": "Fast Lane Drive Thru",
  "fastLaneDriveThruDescription": "Drive up and let us know you placed an online order.",
  "fastest": "Fastest",
  "fat": "Fat",
  "favorite": "Favorites",
  "favoriteLocationRequiredError": "Favorite location is required.",
  "favoriteRemoveAllModalBody": "Removing all the items in this order will delete your favorite. Are you sure you want to delete this order?",
  "favoriteRemoveAllModalHeader": "Wait! You have no items!",
  "fees": "Fees",
  "feet": "feet",
  "fetchCoordinatesError": "We couldn’t find coordinates for the selected address. Please try again.",
  "fiber": "Fiber",
  "fileDownloadedMessage": "The file has been downloaded successfully.",
  "fileDownloadedTitle": "File Downloaded",
  "filter": "filter",
  "filterByMonth": "Filter by month",
  "filters": "filters",
  "findARestaurant": "Find a Restaurant",
  "finishOrder": "Finish order",
  "finishYourProfile": "Complete your profile",
  "firstName": "First name",
  "fish": "fish",
  "forInternalUseOnly": "For Internal Use Only",
  "forItemAvailability": "For availability",
  "forceUpdateModalCaption": "Update Required.",
  "forceUpdateModalSubCaption": "Download the latest version of the app to keep on flame-grilling.",
  "forceUpdateModalTitle": "News Flash!",
  "forterSignUpError": "It seems that you may already have an account with us. Please try logging in to your existing account or contact support for assistance.",
  "foundation": "Foundation",
  "free": "FREE",
  "freeDeliveryOverAmount": "$0 Delivery Fee on orders over {amount}",
  "friday": "Friday",
  "from": "From",
  "fromStartDateToEndDate": "From {startDate} to {endDate}",
  "fullMenu": "Full Menu",
  "futureDateOfBirthProvided": "Date of birth cannot be a future date",
  "geographicalFee": "Geographical Fee",
  "geographicalFeeCO": "CO Retail Delivery Fee",
  "geographicalFeeDescription": "Additional fee charged in your area by the delivery aggregator.",
  "giftCard": "Gift Card",
  "giftCardAddingError": "Gift card details may be incorrect or we are experiencing issues with your card, please try again or check with the issuer.",
  "giftCardAlreadyRedeem": "Gift Card was already redeemed.",
  "giftCardExists": "Gift Card already exists in payment methods. You can only have one gift card in payment methods.",
  "giftCardNumber": "Gift Card Number",
  "giftCardNumberIsNotValid": "Gift Card Number is not valid",
  "giftCardNumberIsRequired": "Gift Card number is required",
  "giftCardUnavailableAtLocationError": "Prepaid Cards are unavailable at this location. Please select another form of payment.",
  "giftCardUnavailableAtLocationErrorHeading": "Payment Failed",
  "gluten": "gluten",
  "goToDeviceSettings": "Go to your device settings to allow camera access. We use your camera to let you take photos within the app",
  "goToHomepage": "Go to Homepage",
  "goodDayPeriodX": "Good {dayPeriod}, {name}",
  "googlePay": "Google Pay",
  "googlePayPaymentNotAvailable": "We currently don’t accept Google Pay on our websites. Please select or add a new payment method.",
  "gotIt": "Got It!",
  "grabYourReward": "Grab your reward!",
  "hamburgerMenuAriaLabel": "Navigate to account menu",
  "haveItYourWay": "Have it your way",
  "here": "here",
  "hiX": "Hi, {name}",
  "hideDetails": "Hide Details",
  "higherPricesWarning": "Prices may be higher",
  "history": "history",
  "historyTab": "History",
  "historyTitle": "History",
  "home": "Home",
  "homepage": "Homepage",
  "hours": "Hours",
  "hoursOfOperationFallbackMessage": "Closed",
  "howItWorks": "How It Works",
  "howItWorksLower": "How it works",
  "howToRedeem": "How to Redeem",
  "howWouldYouLikeToReceiveThisOrder": "How would you like to receive this order?",
  "huaweiDownloadApp": "Huawei Download app button",
  "imCraving": "I'm craving",
  "image": "image",
  "inRestaurantOrder": "Order In-Restaurant ",
  "inStoreAmenities": "In-Store Amenities",
  "incentiveFeedbackCartRequirement": "Add the required items to your cart in order to redeem.",
  "incentiveFeedbackCartRequirementExclusion": "Can't be combined with:",
  "incentiveFeedbackDefault": "Your cart does not meet the requirements to redeem this {incentiveType}.",
  "incentiveFeedbackExpired": "This offer expired on {endDate}.",
  "incentiveFeedbackInvalidDay": "This offer is only valid on {targetValue}.",
  "incentiveFeedbackInvalidStore": "This {incentiveType} is not available at your selected restaurant.",
  "incentiveFeedbackInvalidTime": "This {incentiveType} is only valid between {startTime} and {endTime}. Check back at {startTime} to redeem!",
  "incentiveFeedbackMaxRedemptions": "You have surpassed your allotted redemptions for this {incentiveType}.",
  "incentiveFeedbackNotAvailableInStore": "Not available at this location",
  "incentiveFeedbackOfferNotAvailable": "Sorry, your offer is no longer available.",
  "incentiveFeedbackOutOfDayPart": "Currently not available. Please check back later!",
  "incentiveFeedbackOutOfDayPartTime": "Available starting at {time}",
  "incentiveFeedbackPaymentMethod": "You must pay with {targetValue} in order to redeem this {incentiveType}.",
  "incentiveFeedbackServiceMode": "This {incentiveType} is only available for {targetValue}.",
  "incentiveFeedbackSubtotal": "Your subtotal must be ${targetValue} to redeem this {incentiveType}. Add ${calculatedValue} to redeem.",
  "incentiveFeedbackWithinCooldown": "You have recently used an offer. You will be able to use another one in {calculatedValue} minutes.",
  "incentiveMessage": "{incentiveType} will be automatically added to your account once your Challenge is completed.",
  "included": "Included",
  "incomplete": "Incomplete",
  "incrementAriaLabel": "increment-{productName}",
  "info": "Info",
  "information": "Information",
  "instructions": "Instructions",
  "instructionsPlaceholder": "Tell the driver where to leave your order",
  "instructionsTooLong": "Instructions must be less than 200 characters.",
  "insufficientBalanceReloadAgain": "Insufficient prepaid balance, please reload again to checkout.",
  "invalidAddressLine2": "Name is missing. Please enter your name.",
  "invalidDateMissingFields": "Invalid date: {missingFields} {count, plural, one {field is} other {fields are}} required",
  "invalidDateOfBirthProvided": "Invalid date of birth provided",
  "invalidEmail": "Invalid Email",
  "invalidInstructions": "Instructions contain unsupported characters.",
  "invalidOfferError": "Your offer is invalid.",
  "invalidOffersRemoved": "Invalid offers have been removed.",
  "invalidOtpProvided": "The code you entered doesn't match the code we sent. Check your messages and try typing it in again.",
  "invalidPaymentMethodError": "Your payment method is invalid. Please try a different payment method",
  "invalidPhoneNumberFormat": "Invalid phone number format. Please enter a valid number.",
  "invalidReloadError": "We were unable to reload your card",
  "invalidTipAmountError": "Please submit a valid tip amount.",
  "invalidVehicleDescription": "Please enter your Vehicle Description to proceed or try a different service mode.",
  "iosDownloadApp": "IOS Download app button",
  "isHalalTitle": "halal restaurant",
  "issueWithMyItems": "Issue with my item(s)",
  "issuesDuringExperience": "If you experienced any issues during your ordering experience, please",
  "item": "Item",
  "itemAddedToCart": "One {itemName} has been added to your cart.",
  "itemCurrentlyNotAvailable": "Item is currently unavailable!",
  "itemFavorited": "Item saved to favorites!",
  "itemFavoritedError": "Oops! There was an error with your favorite. Please try again later.",
  "itemNotAvailable": "Item not available",
  "items": "Items",
  "itemsUnavailable": "Items Unavailable",
  "justMoreToReachNextLevel": "Just {points} more to reach the next level",
  "keepAddress": "Keep Address",
  "keepCurrentLocation": "Keep Current Location",
  "kilometers": "km",
  "languageAndRegion": "Language and Region",
  "languageAndRegionSelector": "Language and region selector",
  "learnMore": "Learn More",
  "leaveNow": "Leave Now",
  "leaveWithoutSaving": "Leave Without Saving",
  "left": "Left",
  "legal": "Legal",
  "letsGetStarted": "Let's get started, {userName}!",
  "letsGo": "Let's go!",
  "limitReached": "Limit Reached",
  "limitedTimeOffer": "Limited time offer",
  "linkOpensInNewTab": "Link opens in new tab",
  "list": "List",
  "listOfWordsLayout": "{position, select, first {} last { and } other {, }}{word}",
  "listOfWordsLayoutOr": "{position, select, first {} last { or } other {, }}{word}",
  "listbox": "listbox",
  "loadMore": "Load More",
  "loadWith": "Load with",
  "loading": "One moment please!",
  "loadingYourOrder": "Loading Your Order",
  "localeDateTime": "en-US",
  "location": "Location",
  "locationSearch": "We are looking for restaurants.",
  "locked": "Locked",
  "logIn": "Log In",
  "logInWithApple": "Continue with Apple",
  "logInWithExistingEmail": "An account with the given email already exists. Would you like to log in instead?",
  "logInWithGoogle": "Continue with Google",
  "logo": "BK logo",
  "looksLikeWereExperiencingIssues": "Looks like we are experiencing issues. Please try again!",
  "lostNetworkConnectivity": "Looks like you have lost network connectivity",
  "loyaltyCardImage": "Loyalty card image",
  "loyaltyCreateAccountHeadline": "Welcome back to",
  "loyaltyHistorySignUp": "Sign up or Log In to Redeem, Earn and access to your Crowns history",
  "loyaltyInfoImage": "Loyalty info image",
  "loyaltyNotAvailableAtDeliveryModePrimaryCta": "Select Restaurant",
  "loyaltyNotAvailableAtDeliveryModeTitle": "Loyalty Code Requires Restaurant Selection",
  "loyaltyNotAvailableAtThisRestaurant": "Loyalty is not available at this restaurant",
  "loyaltyNotAvailableAtThisRestaurantDescription": "Royal Perks is coming soon to this restaurant. In the meantime...Earn Crowns by placing a mobile order.",
  "loyaltyNotAvailableAtThisRestaurantPrimaryCta": "Place Mobile Order",
  "loyaltyNotAvailableAtThisRestaurantTitle": "Coming Soon to this Location ...",
  "loyaltyPoints": "You have {points} Crowns",
  "loyaltyPointsExpiring": "You have {points} Crowns expiring,",
  "loyaltyPointsUseThemBy": "use them by {date}.",
  "loyaltyProfileEarnCrownsBody": "Get 10 Crowns for every $1 spent on eligible purchases.",
  "loyaltyProfileEarnCrownsTitle": "Earn Crowns when you order:",
  "loyaltyProfileJoinTheProgram": "Join the program and start earning crowns and redeem rewards.",
  "loyaltyProfileMeetTheProgram": "Meet Royal Perks Rewards",
  "loyaltyProfileRedeemCrownsBody": "Redeem Crowns for your favorite BK® menu items.",
  "loyaltyProfileRedeemCrownsTitle": "Turn Crowns into free food:",
  "loyaltyProfileUnlockOffersBody": "Enjoy special promotions just for members in the App.",
  "loyaltyProfileUnlockOffersTitle": "Unlock exclusive offers:",
  "loyaltyRewards": "Loyalty Rewards",
  "loyaltyUnavailableInRegionOops": "Oops!",
  "lupin": "lupin",
  "main": "main",
  "mainMenu": "Main menu",
  "maintainYourPoints": "Make a purchase to maintain your Crown balance",
  "map": "Map",
  "maxAttemptsReached": "You've reached the maximum login attempts we allow.",
  "maxAttemptsReachedRequestNewCode": "You've reached the maximum login attempts we allow, please request a new code below.",
  "mayContainAllergens": "May contain: {allergens}",
  "mayContainAllergensViaSharedEquipment": "May contain via shared equipment: {allergens}",
  "media": "Media",
  "menu": "Menu",
  "menuAcceleratorCartMessage": "Delicious & rewarding — {points} Crowns coming your way!",
  "menuAcceleratorReviewOrderMessage": "Nice pick! You're getting {points} Crowns with this order",
  "menuEmptyScreenDesktopMessage": "Refresh the page, and we'll get it sizzling in no time!",
  "menuEmptyScreenMessage": "Pull to refresh, and we'll get it sizzling in no time!",
  "menuEmptyScreenTitle": "Our menu needs extra grilling",
  "message": "Message",
  "messageAllowLocation": "Please go to settings and allow location",
  "meters": "m",
  "method": "Method: {serviceMode}",
  "miles": "miles",
  "milk": "milk",
  "min": "min",
  "minimumPriceError": "Your cart does not meet the minimum price required.",
  "minutes": "minutes",
  "mobile": "Mobile",
  "mobileOrderDriveThru": "Mobile Order Drive Thru",
  "mobileOrderDriveThruAt": "Mobile Order Drive Thru at",
  "mobileOrderDriveThruHours": "Mobile Order Drive Thru Hours",
  "mobileOrderDriveThruOrder": "Mobile Order Drive Thru",
  "mobileOrderDriveThruOrderPlaced": "Mobile Order Drive Thru Placed",
  "mobileOrderLane": "Mobile Order Drive Thru",
  "mobileOrderingAndPickup": "Mobile Ordering & Pickup",
  "mobileOrderingUnavailable": "Mobile ordering is currently unavailable",
  "mobilePickupVehicleDescription": "Help us find you quickly by identifying your vehicle",
  "mobilePickupVehicleDescriptionPlaceholder": "Color and make of your vehicle",
  "mobilePickupVehicleTitle": "Vehicle Description",
  "mode": "Mode",
  "monday": "Monday",
  "month": "Month",
  "monthPlaceholder": "MM",
  "more": "More",
  "moreInfo": "More info",
  "moreItems": "{remainingItems, plural, =0 {} other {{remainingItems}}} {remainingItems, plural, =0 {} one {more item…} other {more items…}}",
  "moreYouDoTheMoreYouUnlock": "The more you do, the more you unlock. And some badges? Well, let’s just say they’re harder to get — and way more fun to flex.",
  "morning": "Morning",
  "mustAddPaymentMethod": "You must Add a Payment Method",
  "mustard": "mustard",
  "myAccount": "My Account",
  "myCode": "My Code",
  "name": "Name",
  "nameOnCard": "Name on card",
  "nameOnCardIsRequired": "Name on card is required",
  "nameRequiredError": "Name is a required field.",
  "nameYourFavorite": "Name Your Favorite",
  "nativePaymentNotAvailable": "We currently don’t accept Google or Apple Pay on our websites. Please select or add a new payment method.",
  "navHome": "Home",
  "navMenu": "Menu",
  "navMyCode": "My Code",
  "navOffers": "Offers",
  "navRewards": "Rewards",
  "nearby": "Nearby",
  "needHelp": "Need Help?",
  "needMoreHelpSendUsAMessage": "Need more help? Send us a message",
  "new": "New",
  "newBalance": "New Balance: ",
  "newCodeSent": "New code has been sent to your email!",
  "newExclame": "New!",
  "news": "News",
  "next": "Next",
  "nextCustomize": "Next, Customize",
  "nextReviewYourMeal": "Next, Review your Meal",
  "nextReviewYourSelection": "Next, Review Your Selection",
  "nextSelectYourDrink": "Next, Select Your Drink",
  "nextSelectYourSide": "Next, Select Your Side",
  "niceWork": "Nice work, {userName}! You have",
  "no": "No",
  "noCourierName": "No Name",
  "noCourierPhone": "Not Available",
  "noDirectPayAndNoPrepaidMethodError": "We are unable to accept your payment at this time. Please try again later.",
  "noFavoritesHeader": "Favorites",
  "noFavoritesSubheader": "Favorite an item from your cart or recents to save it as a favorite.",
  "noInternetConnection": "No internet connection",
  "noItemsFitCriteria": "No items fit your search criteria",
  "noLocationsMatchYourSearch": "There are no locations that match your search.",
  "noOrdersItemsYet": "RECENT ORDERS & ITEMS WILL APPEAR HERE",
  "noPaymentMethodOnFile": "You currently have no payment methods on file",
  "noRecentItemsHeader": "No Recent Items Yet",
  "noRecentItemsSubheader": "Place an order to see your recent items here.",
  "noThankYou": "No thank you",
  "nonAvailableItemInStore": "Not available at this restaurant",
  "nonAvailableOfferUntil": "This coupon is not available until {time}. Please check back later!",
  "nonAvailableReward": "This reward is not available for redemption.",
  "nonAvailableRewardUntilX": "This reward is not available until {time}. Please check back later!",
  "nonTraditionalStoreDrawerHeader": "This is a special location",
  "notARoyalPerksMember": "Not a Royal Perks Member?",
  "notApplicable": "N/A",
  "notAvailableAtStore": "Not available at selected store",
  "notNow": "Not Now",
  "notSelected": "Not selected",
  "notValidEmailError": "That doesn't look like a valid email.",
  "notValidNameError": "That doesn't look like a valid name.",
  "notValidPhoneNumberError": "That doesn't look like a valid phone number",
  "notifications": "Notifications",
  "now": "Now",
  "numberOfCrowns": "{crowns} crown{crowns, plural, one {} other {s}}",
  "nutritionCommitment": "At Burger King, we're committed to serving our Guests great-tasting food made with quality ingredients. Our iconic Whopper sandwiches—crafted with flame-grilled, 100% real beef and freshly cut toppings—are a proud example of that promise. As the Home of Have It Your Way, we're continually innovating to create delicious recipes using ingredients our Guests can trust.",
  "nutritionalInformationAndAllergen": "Nutritional, Allergen and Ingredient Information",
  "nycRestaurantHealthRatings": "NYC Restaurant Health Ratings",
  "offer": "Offer",
  "offerAddedToCart": "Offer added to cart",
  "offerApplied": "Offer Applied",
  "offerAppliedSuccess": "Offer has been removed from your order",
  "offerConfirmDialogBody": "Closing this screen will mark this coupon as redeemed. Are you sure?",
  "offerConfirmDialogConfirmLabel": "Continue",
  "offerConfirmDialogHeading": "All Finished?",
  "offerExpires": "Expires {date}",
  "offerGroupBadgeLabel": "Offer Group",
  "offerNotApplied": "Offer not applied",
  "offerNotAvailable": "Offer not available",
  "offerNotAvailableInRestaurantPos": "An item in your offer is not available at this restaurant.",
  "offerTerms": "Offer Terms",
  "offers": "Offers",
  "offersAvailableAt": "Redeem again at {time}",
  "offersAvailableAtFallback": "One more hour and you can redeem more.",
  "offersCooldownDescription": "Offers will become available again in {minutes} minutes.",
  "offersCooldownDescriptionFallback": "Offers will become available again soon.",
  "offersCooldownInfo": "Limit one offer per visit. All other offers become unavailable for {period} minutes.",
  "offersCooldownTitle": "You just redeemed an offer",
  "offersDisclaimer": "One per customer. No substitutions. Non valid on delivery or with other coupons or offers. Available at participating US Popeyes® locations (except AK & HI). Void where prohibited or if reproduced, altered or transferred. Tax may apply. Cash value at 1/100¢. TM & © 2021 PLKI. All rights Reserved. Expires {deactivationDate}",
  "offersNoOffersAvailable": "No Offers Available",
  "offersYouCanStillEnjoyYourFavorites": "You can still enjoy your favorites by ordering from the menu.",
  "ok": "Ok",
  "okay": "Okay",
  "okayButtonText": "Okay",
  "oneOfferPerOrder": "Only one offer per order",
  "only": "only",
  "oopsComeBackTomorrow": "Oops! Come back tomorrow at {storeTime} or select another store.",
  "oopsSomethingWentWrong": "Oops Something Went Wrong",
  "open": "Open",
  "open24Hours": "Open 24 hours",
  "openDeviceSettings": "Go to Settings",
  "opensAt": "Opens at {time}",
  "option": "option",
  "optionalInformation": "Optional Information",
  "options": "options",
  "or": "or",
  "order": "Order",
  "orderCancelled": "Order Cancelled",
  "orderCompleted": "Order Completed!",
  "orderConfirmation": "Order Confirmation",
  "orderConfirmationInstructionsConfirmed": "Come in and head to the Pickup area at the counter to check in with a Team Member. Then find a seat to enjoy!",
  "orderConfirmationInstructionsDelivery": "We are preparing order and it will be delivered to your address when ready.",
  "orderConfirmationInstructionsDriveThru": "Drive up to the ordering screen and let us know you ordered online for {userName}.",
  "orderConfirmationInstructionsMobileDriveThru": "Drive up to our dedicated Mobile Order Lane and we'll walk your order out to your car.",
  "orderConfirmationInstructionsTakeOut": "Head to the Pickup area at the counter to check in with a Team Member.",
  "orderConfirmationNumber": "Order #{orderNumber}",
  "orderDate": "Order Date",
  "orderDelivery": "Order Delivery",
  "orderDetailsHeading": "Order Details",
  "orderFailureMessage": "We encountered an error creating your order. We are aware of the issue and are working to resolve it. Please try again or contact {link}",
  "orderFailureMessageForApplePay": "Your payment with Apple Pay failed. Your card will not be charged and any pending transaction are typically released in 24-48 hours.",
  "orderFailureMessageForGooglePay": "Your payment with Google Pay failed. Your card will not be charged and any pending transaction are typically released in 24-48 hours.",
  "orderHere": "Order Here",
  "orderInProgress": "Order in progress",
  "orderIsBeingMadeYourWay": "{userName}, your order is being made your way!",
  "orderName": "Order Name",
  "orderNow": "Order Now",
  "orderNumber": "Order number",
  "orderPayment": "Order Payment",
  "orderPickup": "Order Pickup",
  "orderPlaced": "Order Placed",
  "orderProcessingDisclaimer": "We won't start preparing your order and your card will not be charged until you press \"I'm Here\" on the next screen.",
  "orderProcessingDisclaimerCashPayment": "We won't start preparing your order until you press \"I'm Here\" on the next screen.",
  "orderTime": "Order time",
  "orderingFrom": "Ordering from",
  "other": "Other",
  "otherDiscounts": "Other Discounts",
  "otpFormHeadline": "Unlock exclusive offers, rewards & experiences",
  "ourMenu": "Our Menu",
  "outForDelivery": "Out for Delivery",
  "outOfDayparts": "{dayParts} only",
  "partnerOffers": "Partner Offers",
  "partnershipWalmartDescription": "25% off for 1 order daily + Free Whopper® with purchase every 3 months.",
  "partnershipWalmartTitle": "BK & Walmart+",
  "partnerships": "Partnerships",
  "payWithEase": "Pay with ease using your code.",
  "payment": "Payment",
  "paymentAddingError": "Credit card details may be incorrect or we are experiencing issues with your card, please try again or check with your bank.",
  "paymentDeclined": "We won’t be able to complete this transaction. Check with your card provider for details.",
  "paymentDeclinedDisclaimer": "Your order remains in the cart, you can go back to try again",
  "paymentDeclinedHeading": "Oops. Looks like something went wrong.",
  "paymentDeletingError": "There was an error deleting your payment method.",
  "paymentDetails": "Payment Details",
  "paymentDetailsError": "Something went wrong with your payment information. Please try again or contact support {link}.",
  "paymentDetailsErrorHeading": "Payment Error",
  "paymentLoadingError": "There was an error loading your payment method.",
  "paymentMethod": "Payment Method",
  "paymentMethodNotAvailable": "Not available",
  "paymentMethods": "Payment Methods",
  "paymentNotSupported": "Please try selecting another payment method.",
  "paymentNotSupportedHeading": "Oops. This restaurant is currently unable to accept your payment method.",
  "paymentXEndingInY": "{cardType} ending in {ccLast4}",
  "paypal": "PayPal",
  "peanuts": "peanuts",
  "perServing": "Per serving",
  "perks": "Crowns",
  "phoneAppStoresDisclaimers": "Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc. Google Play is a trademark of Google Inc. Terms apply.",
  "phoneNumber": "Phone Number",
  "phoneNumberDisclaimer": "The phone number on file will be used by drivers to get in touch with you. By continuing, you agree to share your contact information with the DoorDash or Postmates drivers that will deliver your food.",
  "phoneNumberPlaceholder": "+13050000000",
  "phoneNumberRequired": "Phone Number (Required)",
  "phoneNumberRequiredError": "Phone number is a required field.",
  "phoneNumberTooLongError": "Phone number inserted is too long.",
  "phoneNumberTooShortError": "Phone number inserted is too short.",
  "pickALabel": "Pick a Label (Required)",
  "pickUp": "Pickup",
  "pickUpAt": "Pickup at",
  "pickUpOnly": "Pickup only",
  "pickUpOrder": "Pickup Order",
  "pickUpOrderPlaced": "Take Out Order Placed",
  "pickUpOrderSuccessfulAlert": "Your order has been successful, enjoy your order. Your order number is {orderNumber} in the {brand} at {address}.",
  "pickUpTime": "Pickup time",
  "pickupNowEta": "Ready in 5-7 minutes",
  "pickupTime": "Pickup Time",
  "pickupWindow": "Closing in {minutes} min — please pickup as soon as possible!",
  "placeAnOrderToEarn": "Place an order to earn",
  "placeOrder": "Place Order",
  "placeOrderDescription": "Place {serviceMode} order for {price}",
  "placeSecureOrder": "{secureOrderIcon} Place Secure Order",
  "placingOrder": "We are sending you order to the store.",
  "placingOrderCheckoutBtn": "Placing Order",
  "pleaseHaveYourCashReady": "Please have your cash ready",
  "pleaseProvideAValid16Digit": "Please enter a valid 16-digit card number.",
  "pleaseProvideTheCardName": "Please enter the name on the card.",
  "pleaseProvideTheCreditCardCvv": "Please enter the CVV.",
  "pleaseProvideTheExpirationDate": "Please enter the expiration date.",
  "pleaseProvideTheZipCode": "Please enter the zip code.",
  "pleaseReAuthenticateToContinue": "Please re-authenticate to continue. You will be logged out momentarily for security purposes.",
  "pleaseSelect": "Please select",
  "pleaseSelectOne": "Please select one",
  "pleaseTryAgainLater": "Please try again later.",
  "pleaseTryToRefresh": "Please try to refresh.",
  "points": "Crowns",
  "pointsEarned": "{pointsEarned, plural, one {You've earned {pointsEarned} Crown!} other {You've earned {pointsEarned} Crowns!}}",
  "pointsEarnedLabel": "Crown{points, plural, one {} other {s}} Earned",
  "pointsExpired": "Crown{points, plural, one {} other {s}} Expired",
  "pointsRedeemed": "Crown{points, plural, one {} other {s}} Redeemed",
  "pointsUsed": "Crown{points, plural, one {} other {s}} Used",
  "postalCode": "Postal Code",
  "postalCodeInvalid": "Postal Code Invalid",
  "postalCodeRequiredError": "Postal Code Required",
  "preferences": "Preferences",
  "prepDeliveryTime": "Prep & Scheduled Time",
  "prepPickUpTime": "Prep & Pickup Time",
  "prepaidCardBalance": "{cardAlias} Card Balance",
  "previous": "Previous",
  "price": "Price: {price}",
  "priceMismatchDetected": "Price Mismatch Detected",
  "pricedAndAvailableError": "We ran into a temporary technical issue processing your order. Please try again.",
  "pricesDiscountsAndAvailabilityAreSbujectToChangeWhenYouReorder": "Prices, discounts and availability are subject to change when you reorder.",
  "primaryNavLinks": "Primary Navigation",
  "privacyPolicy": "Privacy Policy",
  "prizes": "Prizes",
  "product": "Product",
  "productDetailCloseContent": "Do you want to leave without finishing?",
  "productDetailCloseHeading": "Leaving Now",
  "productDetailGoBack": "Go back to {screen}",
  "productDetailPickerCustomizationGoBack": "Go back to {screen} customization",
  "productDetailPickerGoBack": "Go back to {screen} product details",
  "productDetailResetContent": "Selecting a new option will cause previous customizations to be lost.",
  "productDetailResetHeading": "Reset Customizations",
  "productInformation": "Product Information",
  "profile": "Profile",
  "profileCompletionStarted": "Profile Completion started!",
  "profileCompletionUpdated": "Profile Completion Updated!",
  "progressbar": "progressbar",
  "promoCodeAddedToOffers": "Promo Code added to Offers",
  "promoCodeBadgeLabel": "Promo Code",
  "promoCodeCTA": "Have a Promo Code?",
  "promoCodeLabel": "Enter promo code",
  "promoCodeOfferExpiredCode": "The code you entered has expired",
  "promoCodeOfferInvalidCode": "Invalid Promo Code Entered",
  "promoCodeOfferRedeemedCode": "The code you entered has already been redeemed",
  "proteins": "Proteins",
  "providedBy": "Provided by",
  "province": "Province",
  "pspPaymentDeclinedMessage": "Hi {name}, your transaction was declined. Contact your card issuer for assistance.",
  "pspPaymentDeclinedTitle": "Declined",
  "pspPaymentDeclinedTransactionForterMessage": "Hi {name}, your transaction was declined.  Try a different payment method.",
  "pspPaymentDeclinedTransactionForterTitle": "Declined Transaction",
  "pspPaymentDeclinedTransactionMessage": "Hi {name}, your payment exceeded the daily approval limit. Contact your card issuer or select a different payment method.",
  "pspPaymentDeclinedTransactionTitle": "Declined Transaction",
  "pspPaymentExpiredCardMessage": "Hi {name}, your card appears to be expired. Double-check the date and try again.",
  "pspPaymentExpiredCardTitle": "Expired Card",
  "pspPaymentIncorrectInformationMessage": "Hi {name}, the card information you entered is incorrect. Check your details and try again.",
  "pspPaymentIncorrectInformationTitle": "Incorrect Card Information",
  "pspPaymentInsufficientFundsMessage": "Hi {name}, there was an issue processing your payment. Check your account balance or try using a different payment method.",
  "pspPaymentInsufficientFundsTitle": "Insufficient Funds",
  "pspPaymentInvalidCardMessage": "Hi {name}, the card number you entered is invalid. Check your details and try again.",
  "pspPaymentInvalidCardTitle": "Invalid Card",
  "pspPaymentRestrictedCardMessage": "Hi {name}, your card is restricted from making this transaction. Try a different payment method or contact your card issuer for more information.",
  "pspPaymentRestrictedCardTitle": "Restricted Card",
  "pspPaymentStoreErrorMessage": "Hi {name}, this store is not accepting payments right now. Please try another store.",
  "pspPaymentStoreErrorTitle": "Store Error",
  "pspPaymentUnableToProcessMessage": "Hi {name}, there’s a problem with your payment. Get in touch with your card issuer or select another payment option.",
  "pspPaymentUnableToProcessTitle": "Unable to Process",
  "pullToRefresh": "Pull down further to refresh",
  "purchaseAmount": "Amount",
  "push": "Push",
  "pypestreamWelcomeAnon": "Hey there! I'm the {brand} digital assistant, here to help resolve any order issues and answer your questions.  One moment while we look you up.",
  "pypestreamWelcomeUser": "Hey {name}! I'm the {brand} digital assistant, here to help resolve any order issues and answer your questions. One moment while we pull up your order history.",
  "qty": "Qty: ",
  "quantity": "Quantity",
  "quantityAriaLabel": "Quantity {productQuantity} of {productName}",
  "questCardPendingOrdersMessage": " of {totalSteps} Orders Completed",
  "questCheckNetworkText": "Please check your internet connection and try again",
  "questEarnPoints": "Earn {points}",
  "questLoadError": "Sorry we couldn't load the {quest}",
  "questOnYourWay": "You're on your way.",
  "questOrderCompleted": "Order Completed",
  "questPointsEarned": "{points} Earned",
  "questTerms": "{quest} Terms",
  "questUserGreatWork": "Great work, {username}!",
  "question": "Question",
  "quests": "Quests",
  "quickPay": "Quick Pay",
  "receipt": "Receipt",
  "recent": "Recent",
  "recentItems": "Recent Items",
  "recentItemsFailed": "Oops! Recent Items failed to load",
  "recentOrders": "Recent Orders",
  "recentOrdersDisclaimer": "Prices, discounts and availability are subject to change when you reorder.",
  "recentOrdersEmptySubHeader": "Go start a new order now!",
  "recents": "Recents",
  "redeem": "Redeem",
  "redeemApply": "Use {points}",
  "redeemFreeBK": "Redeem Free BK",
  "redeemInNext": "Redeem in the next",
  "redeemInRestaurant": "Redeem in Restaurant",
  "redeemNow": "Redeem Now",
  "redeemOffers": "Redeem Offers",
  "redeemRemove": "Remove {points}",
  "redeemReward": "Redeem your reward",
  "redeemTab": "Redeem",
  "redeemedRewards": "{redeemedRewards, plural, one {You've redeemed {redeemedRewards} reward.} other {You've redeemed {redeemedRewards} rewards.}}",
  "redeeming": "Redeeming",
  "redemptionCode": "Redemption code",
  "refresh": "Refresh",
  "refundEligibilityInfo": "Orders are eligible for partial or full refunds. Select from your orders below to submit for a refund.",
  "regular": "Regular",
  "reload": "Reload",
  "reloadCard": "Reload Card",
  "reloadCrownCardCardError": "There was an error loading your BK Crown Card.",
  "reloadExplanation.bk": "Your current balance won’t cover the cost of today’s order. Select a payment method to load {reloadAmount} to your gift card. Your order will be placed automatically.",
  "remove": "Remove",
  "removeAddressBody": "Are you sure you want to remove it from your saved addresses? This action can't be undone.",
  "removeAddressHeading": "Delete this address?",
  "removeExpiredOfferItem": "We removed items in your cart that are no longer available at this time.",
  "removeFavorite": "Remove from Favorites?",
  "removeFavoriteConfirm": "Are you sure you want to remove this favorite?",
  "removeFavoriteOrderSucess": "Order removed from favorites.",
  "removeFavoriteSucess": "Your favorite has been removed.",
  "removeFromCartSuccess": "{itemName} removed from cart",
  "removeItem": "Remove Item",
  "removeItemFromCart": "Are you sure you want to remove your {item} from your cart?{offerText}",
  "removePaymentMethod": "Remove payment method",
  "removeRewardsFromCart": "Remove rewards from cart",
  "reorder": "Reorder",
  "reorderWithOrderDescription": "Reorder {orderDesc}",
  "reorderWithOrderNumber": "Reorder number {ticketNumber}",
  "replace": "Replace",
  "replaceItem": "Replace Item",
  "replaceReward": "Replace Reward",
  "replaceRewardText": "You already have a reward selected. Are you sure you want to replace it?",
  "requestMyInfo": "Request my info",
  "requestedAmount": "Requested Amount",
  "required": "Required",
  "requiredDate": "A valid date is required",
  "requiredField": "This is a required field",
  "resendCode": "Resend Code",
  "resendCodeSuccess": "Email resent. Please check your email.",
  "reset": "Reset",
  "resetCustomizationsDescription": "Selecting this option will clear any customization applied to your order. Would you like to continue?",
  "resetCustomizationsHeader": "Reset Customizations",
  "resetLocationButtonAria": "Click here to reset the map to your current location.",
  "restartPurchaseProcessButton": "Choose a Different Restaurant",
  "restaurantClosed": "Restaurant closed",
  "restaurantClosedDialogBody": "No worries, you can still order from a different restaurant nearby.",
  "restaurantClosedDialogBodyClosestOptionAvailable": "Closest option available:",
  "restaurantClosedDialogBodyDelivery": "Sorry, all delivery restaurants are closed. Try again later or choose pickup.",
  "restaurantClosedDialogBodyLoading": "Searching for a nearby restaurant...",
  "restaurantClosedDialogButton": "Confirm New Restaurant",
  "restaurantClosedDialogButtonCancel": "Choose a Different Restaurant",
  "restaurantClosedDialogButtonDelivery": "Switch to Pickup",
  "restaurantClosedDialogHeading": "Selected Restaurant Closed",
  "restaurantClosedDialogHeadingDelivery": "Delivery Unavailable",
  "restaurantCloses": "Restaurant closes in {minutes} min",
  "restaurantDetails": "Restaurant Details",
  "restaurantPriceChangeToast": "The price of your order was updated",
  "restaurantUnavailableErrorMessage": "The store you selected isn't able to accept mobile orders at this time.",
  "restaurantUnavailableErrorTitle": "Restaurant Currently Unavailable",
  "restaurants": "Restaurants",
  "resultsLeft": "{count} results left",
  "retakePhoto": "Retake",
  "retry": "Retry",
  "review": "Review",
  "reviewPhoto": "Review Photo",
  "reviewYourMeal": "Review Your Meal",
  "reviewYourSelection": "Review Your Selection",
  "reward": "Reward",
  "rewardRedeemed": "Reward Redeemed",
  "rewardSavings": "Reward Savings",
  "rewardUnavailable": "Not available",
  "rewards": "Rewards",
  "rewardsMainImage": "Rewards main image",
  "rewardsPolicy": "Rewards Terms",
  "royalPerks": "Royal Perks",
  "royalPerksMembersEnjoy": "Royal Perks members enjoy",
  "salt": "Salt",
  "saturatedFat": "Saturated Fat",
  "saturday": "Saturday",
  "save": "Save",
  "saveAddressDisclaimer": "Please save my phone number and delivery address for faster checkout the next time I place an order.",
  "saveAddressLabel": "Save My Information. {disclaimer}",
  "saveCardDisclaimer": "Save Card, by saving your card you consent for your card to be stored and used for purchases.",
  "saveCardDisclaimerRedesign": "By Saving your card you consent for your card to be stored and used for purchases",
  "saveChanges": "Save Changes",
  "saveFavoriteOrderButton": "Save In Favorites",
  "saveFavoriteOrderNameError": "Please enter an order name.",
  "saveFavoriteOrderSucess": "Order saved to favorites!",
  "saveFavoriteOrderText": "What would you like to name this order?",
  "saveFavoriteOrderUnsaved": "You Have Unsaved Changes",
  "saveFavoriteOrderUnsavedBody": "Do you want to continue without saving your changes in the favorite order?",
  "scan": "Scan",
  "scanSuccessful": "Scan Successful!",
  "searchLocation": "Search Location",
  "searchThisArea": "Search this area",
  "seconds": "seconds",
  "seeDetails": "See details",
  "select": "Select",
  "selectACountry": "Select a country",
  "selectAFilter": "Select a filter...",
  "selectAnyways": "Select Anyways",
  "selectDonationAmount": "Select Donation Amount",
  "selectLanguage": "Select Language",
  "selectLocation": "Select Location",
  "selectOffer": "Select Offer",
  "selectPaymentMethodDrawer": "Select Payment Method",
  "selectRemaining": "Select {amount} More",
  "selectRestaurantToViewOffers": "Select restaurant to view local offers",
  "selectSingleChoice": "Select {amount} {itemName}",
  "selectStore": "Select Store",
  "selectUpTo": "Select up to {amount} {itemName}",
  "selected": "Selected",
  "selectionNotAvailable": "Sorry, your selection is not available.",
  "sendNewCode": "Send New Code",
  "serviceFee": "Service Fee",
  "serviceFeeDescription": "Variable fee consists of {percent}% of your delivery order (excl. taxes).",
  "serviceModeDetailsDineInDescription": "Come in and head to the Pickup area at the counter to check in with a Team Member. Then find a seat to enjoy!",
  "serviceModeDetailsDineInDescriptionV2": "At Counter",
  "serviceModeDetailsDineInHeader": "Dine In",
  "serviceModeDetailsDriveThruDescription": "Drive up and let us know you placed an online order.",
  "serviceModeDetailsDriveThruDescriptionForMobileOrder": "Drive up to our dedicated Mobile Order Lane and we'll walk your order out to your car.",
  "serviceModeDetailsDriveThruDescriptionV2": "At Drive Thru Lane",
  "serviceModeDetailsDriveThruHeader": "Drive Thru",
  "serviceModeDetailsDriveThruHeaderForMobileOrder": "Mobile Order Drive Thru",
  "serviceModeDetailsMobileOrderDriveThruDescriptionV2": "At Mobile Order Drive Thru Lane",
  "serviceModeDetailsPickupDescription": "Head to the Pickup area at the counter to check in with a Team Member.",
  "serviceModeDetailsPickupDescriptionV2": "At Counter",
  "serviceModeDetailsPickupHeader": "Pickup",
  "serviceModeSelectorTitle": "Select your pickup method",
  "serviceModeSwitchedAutomatically": "Selected mode unavailable. Switched automatically.",
  "serviceVisit": "Support Crowns",
  "sesame": "sesame",
  "setRestaurantAsFavorite": "Set this restaurant as a favorite",
  "shareMyLocation": "Share Location",
  "shellfish": "shellfish",
  "shortCodeConfirmationBody": "Your Royal Perks have been added to the order.",
  "showCodeToRedeem": "Show Code to Redeem",
  "showDetails": "Show details",
  "showLess": "Show Less",
  "showMore": "Show More",
  "signIn": "Log In",
  "signInCodeSentToEmailAgain": "Your login code has been sent to your email! Please also check your spam folder.",
  "signInSuccess": "You have successfully logged in.",
  "signInToViewOrders": "Log In To View Orders",
  "signInUp": "Sign Up / Log In",
  "signOut": "Log Out",
  "signOutConfirmSubheader": "Are you sure you want to log out?",
  "signUp": "Sign Up",
  "signUpError": "An error occurred while signing up.",
  "signUpForPromotionalEmails": "Sign Up for Promotional Emails",
  "signUpNow": "Log In",
  "signUpOrLoginToContinue": "Sign Up or Log In to Continue",
  "signUpOrSignIn": "Sign Up or Log In",
  "signUpRoyalPerksForFree": "Sign up for Royal Perks for free and you’ll get the best deals, every day",
  "signUpSuccessSignInFail": "Your account has been created. Please log in to continue.",
  "signUpToContinue": "Sign Up to Continue",
  "signUpToContinueDisclaimer": "Taxes and Fees will be calculated in your final cart. Sign up or log in to review and complete your order.",
  "signupEmailSent": "We just sent an email with login instructions to {email}. Enter verification code below",
  "sitemap": "Sitemap",
  "skip": "Skip",
  "slowNetworkIssue": "We are still processing your request. This may take slightly longer than usual.",
  "smallCartFee": "Small Cart Fee",
  "smallCartFeeDescription": "Additional fixed fee applicable to delivery orders less than {amount} (excl. taxes). You may add items to remove fee.",
  "sms": "SMS",
  "smsSubscriptionConfirmation": "Great! Keep an eye out for a text with the next steps.",
  "smsSubscriptionUpdateError": "There was an error with your subscription request. Please try again later.",
  "sodium": "Sodium",
  "someItemsNotAvailable": "Some Items Not Available",
  "somethingWentWrongRemovingAddress": "Something went wrong while removing the address. Please try again.",
  "somethingWrong": "Something went wrong",
  "sorryMinimumCashApp": "Sorry! Minimum order for paying with Cash App is $1.00. Add more items or change your payment method.",
  "soy": "soy",
  "startNow": "Start Now",
  "startOrder": "Start Order",
  "state": "State",
  "stateIsARequiredField": "State is a required field",
  "storeAddress": "{name}{conditionalLinebreak}{address1}{linebreak}{city}, {stateProvince} {postalCode}",
  "storeClosed": "THE STORE YOU SELECTED ISN'T OPEN AT THIS TIME",
  "storeCurrentlyClosed": "Store Currently Closed",
  "storeIsClosingError": "This store is closing soon and is no longer accepting mobile orders.",
  "storeLocator": "Store Locator",
  "storeLocatorClosePromptBody": "To view the offers available, you need to select a store first. What would you like to do?",
  "storeLocatorClosePromptHeading": "Select a Store to See Offers",
  "storeLocatorEmptyStateDefaultBody": "Search for a restaurant near you.",
  "storeLocatorEmptyStateDefaultTitle": "Find a Location",
  "storeLocatorEmptyStateFavoritesErrorBody": "Looks like something went wrong on our end. Try reloading the page or searching for an address on the Nearby tab.",
  "storeLocatorEmptyStateFavoritesErrorTitle": "Uh oh! Sorry.",
  "storeLocatorEmptyStateFavoritesNoAuthBody": "To set a favorite location, first log in or sign up for an account.",
  "storeLocatorEmptyStateFavoritesNoAuthTitle": "Log In to Save Favorites",
  "storeLocatorEmptyStateFavoritesNoStoresBody": "Tap the heart on a store to save it as a favorite.",
  "storeLocatorEmptyStateFavoritesNoStoresTitle": "No Favorites Yet",
  "storeLocatorEmptyStateNearbyErrorBody": "Looks like something went wrong on our end. Try entering an address or finding your location on map.",
  "storeLocatorEmptyStateNearbyErrorTitle": "Uh oh! Sorry.",
  "storeLocatorEmptyStateNearbyNoLocationBody": "Let us know where you are so we can recommend nearby locations.",
  "storeLocatorEmptyStateNearbyNoLocationTitle": "Find a Location Nearby",
  "storeLocatorEmptyStateNearbyNoStoresBody": "No nearby locations are available at this time. Try entering a new address or city.",
  "storeLocatorEmptyStateNearbyNoStoresTitle": "No Nearby Locations",
  "storeLocatorEmptyStateRecentErrorBody": "Looks like something went wrong on our end. Try reloading the page or searching for an address on the Nearby tab.",
  "storeLocatorEmptyStateRecentErrorTitle": "Uh oh! Sorry.",
  "storeLocatorEmptyStateRecentNoAuthBody": "First log in or sign up for an account.",
  "storeLocatorEmptyStateRecentNoAuthTitle": "Log In to See Recent Locations",
  "storeLocatorEmptyStateRecentNoStoresBody": "You have no recent locations. Let's change that! Try entering an address and placing an order.",
  "storeLocatorEmptyStateRecentNoStoresTitle": "Oh! Hold Up",
  "storeUnavailable": "Store Unavailable",
  "streetAddress": "Street address",
  "submit": "Submit",
  "submitFeedback": "Submit Feedback",
  "submitYourPhoto": "Submit Your Photo",
  "subtotal": "Subtotal",
  "success": "Success",
  "successfullyCreatedSupportCase": "Your support case has been successfully submitted!",
  "successfullyUpdatedUserAccountInfo": "Account information has been updated.",
  "sugar": "Sugar",
  "sulphurDioxide": "sulphur dioxide",
  "sunday": "Sunday",
  "support": "Support",
  "supportFormDeliveryActive": "It looks like your order has not been dropped off yet, if you need additional help please reach out below.",
  "supportFormOrderAlreadyRefunded": "It looks like you have already received a refund for this order, if you need additional help please reach out below.",
  "supportFormRefundGenericError": "We are so sorry you experienced an issue with your order, please describe your issue below.",
  "supportSubcategoryTitle": "{category} issues",
  "supportTopics": "Support Topics",
  "supportTopicsAll": "All Support Topics",
  "takeOut": "Take Out",
  "takeout": "Take Out",
  "tapToSeeDetails": "Tap to see details.",
  "tastySwaps": "Tasty Swaps",
  "tax": "Tax",
  "taxes": "Taxes",
  "taxesAndFees": "Taxes and Fees",
  "taxesAndFeesButtonAriaLabel": "Show taxes and fees",
  "taxesAndFeesNextStep": "Calculated at Final Step",
  "termsAccessibilityLabel": "See terms for {cardTitle}",
  "termsConditions": "Terms & Conditions",
  "termsOfService": "Terms of Service",
  "testing": "testing",
  "textTerms": "BK Royal Perks Text Program",
  "theCardBalanceIs": "The card {cardNumber} has a balance of",
  "theEmailAddressIsInvalid": "The email address you entered is invalid or does not exist. Please try again with a valid email, or contact support.",
  "thereAreErrorsInThisForm": "There are {numberOfErrors} errors in this form",
  "thereIsAnErrorInThisForm": "There is an error in this form",
  "thisMayTakeAFewSeconds": "This May Take A Few Seconds",
  "thursday": "Thursday",
  "time": "Time",
  "tip": "Tip",
  "tipAmountError": "Please use a numeric character.",
  "tipAmountMaxError": "Can't exceed subtotal or be more than $50",
  "tipField": "Enter a tip amount (dollars)",
  "titleAllowLocation": "Your location is not available",
  "to": "to",
  "today": "today",
  "tomorrow": "tomorrow",
  "tooManyAddAccountAttempts": "You've tried adding a payment method too many times recently. Please try again later.",
  "topLevelUnlocked": "Congrats, {userName}! Top level unlocked!",
  "total": "Total",
  "totalChoices": "Choose up to {amount} total",
  "totalItemsInTheOrder": "There are {amount} items in the order",
  "totalPrice": "Total Price: {price}",
  "trackOrder": "Track order",
  "trademarkAndCopyright": "TM & Copyright {year} Burger King Company LLC.",
  "transFat": "Trans Fat",
  "transfer": "Transfer",
  "transferBalance": "Transfer Balance",
  "transferBalanceCompletedMessage": "Congratulations! Your balance has been transferred.",
  "transferBalanceFromAnotherCard": "Transfer balance from another {cardAlias} card",
  "transferBalanceFromPrepaidCard": "Transfer {cardAlias} Card Balance",
  "transferGiftCard": "Transfer Gift Card",
  "transferGiftCardHasABalance": " has a balance of ",
  "transferGiftCardNewBalanceQuestion": " ?",
  "transferGiftCardTheCard": "The card ",
  "transferGiftCardToYourCardFor": " to your Card for a new balance of ",
  "transferGiftCardWouldYouLikeTo": "Would you like to transfer ",
  "transferGiftCardYourCurrentGift": "Your Current Gift Card Balance is ",
  "treeNuts": "tree nuts",
  "tryAgain": "Try again",
  "tuesday": "Tuesday",
  "uhoh": "Uh oh!",
  "unableToPlaceOrder": "Unable To Place Order",
  "unableToProcessOrder": "Unable To Process Order",
  "unableToReloadCardError": "We were unable to reload your card.",
  "unauthenticatedFavoritesHeader": "Log In to Save Favorites",
  "unauthenticatedFavoritesSubtext": "Sign up or log in to save your favorites.",
  "unauthenticatedRecentItemsHeader": "Log In to View Recent Items",
  "unauthenticatedRecentItemsSubtext": "Once you're logged in, your recently ordered items will appear here.",
  "unavailable": "Unavailable",
  "unit": "Unit",
  "unitNumber": "Unit {unitNumber}",
  "unitNumberInput": "Unit",
  "unitNumberLabel": "Unit (Optional)",
  "unitNumberLabelRequired": "Unit (Required)",
  "unitedStates": "United States",
  "unlockCartReq": "to your cart to unlock this deal.",
  "unsavedChangesBody": "You’ve made changes to this address. Do you want to save them before leaving?",
  "unsavedChangesHeading": "Unsaved Changes",
  "unsavedChangesModalDescription": "Do you want to save your customization changes?",
  "unsavedChangesModalHeader": "Unsaved Changes",
  "unsupportedCardType": "Sorry, we don't currently support {cardType}",
  "unverifiedCard": "Unverified Card",
  "upateAddress": "Update Address",
  "update": "Update",
  "updateBrowserLocationSettings": "Please allow location access in your browser and operating system settings.",
  "updateCard": "Update Card",
  "updateCart": "Update Order",
  "updateCartSuccess": "{itemName} updated in cart.",
  "updateDeviceLocationSettings": "Go to your device settings to allow location access for the {brand} app",
  "updateInfoError": "An error occurred updating your information.",
  "updateItem": "Update Item",
  "updateNow": "Update Now",
  "updatePaymentMethod": "Update Payment Method",
  "updateQuantityAndItemWithPrice": "Update {quantity} {itemName} for {price}",
  "uponOrderDelivery": "Upon order delivery",
  "uponOrderPickup": "Upon order pickup",
  "us-calories": "Calories",
  "us-carbohydrates": "Carbohydrates",
  "us-cholesterol": "Cholesterol",
  "us-energyKJ": "Energy (kJ)",
  "us-fat": "Fat",
  "us-fiber": "Fiber",
  "us-proteins": "Proteins",
  "us-salt": "Salt",
  "us-saturatedFat": "Saturated Fat",
  "us-sodium": "Sodium",
  "us-sugar": "Sugar",
  "us-transFat": "Trans Fat",
  "us-weight": "Weight",
  "useCodeAtCashier": "Use code at cashier",
  "useDifferentAddress": "Use Different Address",
  "usePointsToday": "Use your crowns today",
  "useRewards": "My Reward Level",
  "useSavedAddressPhone": "Use Saved Address & Phone",
  "useYourWalmartPlusAccount": "Use your preferred email to sign up or if you are already part of Royal Perks, sign in",
  "usedAllCoupons": "Looks like you have used all of the current coupons\nWe update periodically so keep an eye out for new ones.\nThanks for being a loyal customer.",
  "userAuthEmailNotVerified": "The email provided is not verified by the provider, please make the verification and try again.",
  "userAuthEmailNotVerifiedTitle": "Social Account Login Failed",
  "userAuthLookupFailed": "We have some issues searching the user, please try again in a few min.",
  "userAuthProxyEmail": "We couldn't have access to your email address, please allow us to access it, in another case we are not able to continue. \n\nOn apple devices you have to follow this steps:\n - Go to device configuration\n - Apple ID\n - Password & Security\n - Sign in with Apple\n - Select Burger King app\n - Click on Stop Using Apple ID\n - Try to login again and approve the email access permission",
  "userAwayFromStore": "You seem far away.",
  "userDoesNotExist": "This user does not exist",
  "userPhoneVerified": "You have successfully verified your phone number",
  "userSocialLoginEmailUnavailable": "We are unable to retrieve an email address associated with your {providerType} account.\nPlease verify you have an email connected to this account.",
  "userSocialLoginFailed": "Social Account Login Failed",
  "userSocialLoginGenericErrorDescription": "We encountered an error while validating your social account. Please ensure your credentials are correct, or try using an alternative login method.",
  "validUntil": "Valid Until",
  "validationCode": "Validation code",
  "validationError": "Please check your order details and try again",
  "validationErrorHeading": "Order Error",
  "venmo": "Venmo",
  "verified": "Verified",
  "verifyYourEmail": "Verify Your E-mail",
  "verifyYourEmailInstructions": "In order to access all the features in your account, please verify your e-mail.",
  "view": "View",
  "viewAll": "View all",
  "viewAllRewards": "View all rewards",
  "viewAvailableOffersToast": "An offer was removed when you switched stores.",
  "viewAvailableOffersToastLink": "View available offers at your selected store",
  "viewCart": "View Cart",
  "viewDetails": "View Details",
  "viewDetailsWithOrderNumber": "View details of order number {ticketNumber}",
  "viewHistory": "View History",
  "viewInCart": "View in Cart",
  "viewOnMap": "View on Map",
  "viewOrderWithDescription": "View order {orderDesc}",
  "viewPurchasesAndOffers": "View all of your purchases here, including Crowns earned and Crowns redeemed.",
  "viewRecentOrders": "View Recent Orders",
  "viewStoreHours": "View Store Hours",
  "viewTerms": "View Terms",
  "viewYourPurchases": "View all your purchases here, including\nCrowns earned and redeemed.",
  "visitSupport": "Visit Support",
  "visitSupportForHelpWithYourOrder": "Visit support for help with your order.",
  "visuallyHiddenSignInCodeSentToEmail": "We sent a 6 digit login code to your email address, please type the login code into the input box on the screen.",
  "visuallyHiddenSignInSuccess": "You have been logged in!",
  "visuallyHiddenVerifyingOTP": "Verifying",
  "waitForReply": "Keep an eye on your email inbox – we typically respond within 24 – 48 hours.",
  "waitingForCamera": "Camera is Loading",
  "walmartAccountLinkingInterrupted": "The process of linking your accounts was interrupted",
  "walmartAlreadyLinked": "Hi {firstName}, a Walmart+ account is already connected with your account",
  "walmartConnectWithWalmartPlus": "Connect with Walmart+",
  "walmartDeactivateButton": "Deactivate",
  "walmartEnjoyYourOffers": "Enjoy your Walmart+ Offers!",
  "walmartErrorLinkingAccounts": "We couldn’t link the accounts",
  "walmartLanding25Off": "25% Off BK®",
  "walmartLandingBkWalmartTogether": "BK and Walmart+ together!",
  "walmartLandingDailyOn": "Daily on your digital order",
  "walmartLandingEnjoyYourExclusive": "Enjoy your exclusive offers as a Royal Perks and Walmart+ member:",
  "walmartLandingForDigital": "For digital orders",
  "walmartLandingFreeWhopper": "FREE* Whopper®",
  "walmartLandingItsBetter": "It's better together",
  "walmartLandingLinkYourRoyal": "Link your Royal Perks and Walmart+ membership and get exclusive access to even more Burger King deals:",
  "walmartLandingReadyForMoreSavings": "Ready for even more savings?",
  "walmartLandingWithPurchase": "With purchase every 3 months",
  "walmartLinkAccounts": "Link Accounts",
  "walmartMembershipDeal": "That’s 12 months for only $59!",
  "walmartMembershipDealMonthly": "That’s less than $8 every month for 12 months!",
  "walmartMembershipSignUp": "Walmart+ annual membership",
  "walmartMembershipSignUpMonthly": "Walmart+ monthly membership",
  "walmartOfferBadgeAlt": "Walmart offer logo",
  "walmartPartnerUserAlreadyLinked": "Your Walmart+ membership is already connected with another Royal Perks account {email}",
  "walmartPlusBenefit": "40 % OFF",
  "walmartPlusMembershipDiscount": "Royal Perks members get 40% off Walmart+ annual membership.",
  "walmartPlusMembershipDiscountMonthly": "Royal Perks members get 40% off Walmart+ monthly membership.",
  "walmartSignUpSignIn": "Sign Up/Sign In to Royal Perks",
  "walmartUnlinkBodyDialog": "You’ll be taken to Walmart to cancel these offers.",
  "walmartUnlinkCancelBtnDialog": "No, Keep them",
  "walmartUnlinkConfirmBtnDialog": "Yes, Deactivate",
  "walmartUnlinkTitleDialog": "Deactivate Walmart+ Offers?",
  "walmartWelcomeLinkWithWalmartPlus": "Welcome! Now lets link your Royal Perks account with Walmart+",
  "wayToGo": "Way to go! Time to redeem",
  "waysToOrder": "Ways to order",
  "weFoundStoreCloserToYou": "We found a store closer to you",
  "weFoundStoreCloserToYouV2": "We found a closer restaurant",
  "weHadToRemoveUnavailableItems": "We had to remove a few items that aren’t available at this location",
  "weHaveSelectedClosestStore": "We’ve selected the closest store based on your location.",
  "wednesday": "Wednesday",
  "weight": "Weight",
  "welcome": "Welcome!",
  "welcomeBack": "Welcome Back!",
  "whatDoYouNeedHelpWith": "What do you need help with?",
  "wheat": "wheat",
  "whenYouHitCertainMilestones": "When you hit certain milestones in the BK® App, like ordering your favorites or trying something new, you earn a badge.",
  "whopperCodeErrorMessage": "Error loading code",
  "whopperCodeExpired": "Code expired",
  "whopperCodeSubtitle": "Show this code to the cashier",
  "whopperCodeTitle": "Your Whopper Code",
  "whopperGuarantee": "Whopper Guarantee",
  "whopperQrSubtitle": "Cashier can scan this code",
  "whopperQrTitle": "Or scan this QR code",
  "whyDoYouNeedMyPhoneNumber": "Why do you need my phone number?",
  "work": "Work",
  "wouldYouLikeToAddADifferentCard": "Would you like to add a different {cardAlias} Card?",
  "wouldYouLikeToAddToPrepaidCard": "Would you like to add {amount} to your {cardAlias} Card?",
  "xItems": "{xItems, plural, one {# item} other {# items}}",
  "year": "Year",
  "yearPlaceholder": "YYYY",
  "yes": "Yes",
  "yesAddNewCard": "Yes, Add new {cardAlias} Card",
  "yesTransfer": "Yes, Transfer {amount}",
  "youCompletedYourMonthlyAndProfileChallenges": "You've successfully completed your Profile\nand Monthly Challenge.",
  "youCompletedYourMonthlyChallenge": "You've successfully completed your\nMonthly Challenge.",
  "youCompletedYourProfileChallenge": "You’ve successfully completed your\nProfile Challenge.",
  "youHave": "You have",
  "youHaveSuccessfullySubmittedTheForm": "Your form has been successfully submitted",
  "youQualifyFreeDelivery": "You qualify for $0 Delivery Fee!",
  "youWillBeCharged": "You will be charged {reloadAmount} on your Gift Card.",
  "yourAddress": "Your Address",
  "yourBalanceIs": "Your current balance is {currentBalance}.",
  "yourCart": "Your Cart",
  "yourCourier": "Your Courier",
  "yourCrownOrders": "Your Crown Orders",
  "yourEmail": "Your Email",
  "yourNewCardBalance": "Your new {cardAlias} Card balance is {amount}",
  "yourNewPaymentMethodHasBeenSuccessfullySaved": "Your new payment method has been successfully saved",
  "yourOrder": "Your Order",
  "yourPointsWillExpire": "Your Crowns will expire on",
  "yourSelectedRestaurantIs": "Your selected restaurant is {storeAddress}",
  "yourSelectedStore": "Your selected store",
  "yourWay": "Your Way: ",
  "yourWayToShowOff": "Your way to show off just how much you rule!",
  "yourXPointsAway": "You're {points} crowns away",
  "youreXAwayFromFreeDelivery": "You're {amount} away from $0 Delivery Fee!",
  "youveGotEnoughCrowns": "You've got enough Crowns",
  "zipCode": "Zip Code",
  "zipCodeInvalid": "Zip Code Invalid",
  "zipCodeRequiredError": "Zip code is a required field"
}
